<div class="flex-fill">
  <div class="top-toolbar d-none">
    <a href="javascript:;" [class.disabled]="!actionManager.isUndoable" (click)="onUndo()" matTooltip="Undo">
      <i class="cs-icon cs-icon-undo"></i>
    </a>

    <a href="javascript:;" [class.disabled]="!actionManager.isRedoable" (click)="onRedo()" matTooltip="Redo">
      <i class="cs-icon cs-icon-redo"></i>
    </a>
  </div>

  <div class="zoom-container" #zoomContainer (scroll)="onDocScroll()">
    <div class="doc-container" #docContainer (click)="onDocClick($event)">
      <div *ngIf="isLoading" class="d-flex justify-content-center mt-5">
        <app-loading-section size="3rem"></app-loading-section>
      </div>
      <div class="fields-container">
        <ng-template #signFieldsContainer></ng-template>
      </div>
      <div class="fields-select-box" #selectBox>
        <div class="align-actions-wrapper">
          <ul class="align-actions">
            <li (mousedown)="onAlign(alignments.Left)" i18n-matTooltip matTooltip="Align left side">
              <i class="cs-icon cs-icon-align-left"></i>
            </li>
            <li (mousedown)="onAlign(alignments.Right)" i18n-matTooltip matTooltip="Align right side">
              <i class="cs-icon cs-icon-align-right"></i>
            </li>
            <li (mousedown)="onAlign(alignments.Top)" i18n-matTooltip matTooltip="Align top side">
              <i class="cs-icon cs-icon-align-top"></i>
            </li>
            <li (mousedown)="onAlign(alignments.Bottom)" i18n-matTooltip matTooltip="Align bottom side">
              <i class="cs-icon cs-icon-align-bottom"></i>
            </li>
          </ul>
        </div>
      </div>
      <pdf-viewer
        [src]="templateFileUrl | signatureSecurePdf | async"
        [render-text]="false"
        [original-size]="false"
        [fit-to-page]="true"
        [autoresize]="true"
        (after-load-complete)="onTemplateFileLoaded()"
        style="display: block"
      >
      </pdf-viewer>
    </div>
  </div>
</div>

<div id="field-setting-host"></div>

<div class="zoom-controllers d-none">
  <button
    type="button"
    (click)="onZoomIn()"
    class="zoom-btn zoom-in"
    i18n-matTooltip
    matTooltipPosition="left"
    matTooltip="Zoom In"
  >
    <i class="fal fa-plus"></i>
  </button>
  <button
    type="button"
    (click)="onZoomOut()"
    class="zoom-btn zoom-out"
    i18n-matTooltip
    matTooltipPosition="left"
    matTooltip="Zoom Out"
  >
    <i class="fal fa-minus"></i>
  </button>
  <button
    type="button"
    (click)="onZoomToFitScreen()"
    class="zoom-btn"
    matTooltipPosition="left"
    i18n-matTooltip
    matTooltip="Fit Screen"
    *ngIf="zoomController?.getScale() === 1"
  >
    <i class="fal fa-expand-wide"></i>
  </button>
  <button
    type="button"
    (click)="onResetZoom()"
    class="zoom-btn"
    matTooltipPosition="left"
    i18n-matTooltip
    matTooltip="Reset View"
    *ngIf="zoomController?.getScale() !== 1"
  >
    <i class="fal fa-compress"></i>
  </button>
</div>
